import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./routes/ProtectedRoute";

import UserDashboard from "./pages/user/UserDashboard";
import AdminDashboard from "./pages/admin/AdminDashboard";
import UserList from "./pages/admin/UserList";
import Login from "./pages/Login";
import UserProfile from "./pages/user/UserProfile";
import Home from "./pages/Home";
import PageNotFound from "./pages/PageNotFound";
import DriverDashboard from "./pages/driver/DriverDashboard";
import DriverVehicle from "./pages/driver/DriverVehicle";
import VehicleList from "./pages/driver/VehicleList";
import DriverMapWithDirections from "./pages/driver/DriverMapWithDirections";
import UserMapWithDirection from "./pages/user/UserMapWithDirection";
import Signup from "./pages/Signup";
import Logout from "./pages/Logout";
import DriverProfile from "./pages/driver/DriverProfile";
import ForgotPassword from "./pages/ForgotPassword";
import KycDetail from "./pages/driver/KycDetail";
import LoginPage from "./pages/LoginPage";
import Config from "./pages/admin/Config";
import Geofence from "./pages/admin/Geofence";
import AdminVehicle from "./pages/admin/AdminVehicle";
import Countries from "./pages/admin/Countries";
import Cities from "./pages/admin/Cities";
import ChatMsg from "./pages/admin/ChatMsg";
import AdminLogin from "./pages/AdminLogin";
import AdminProfile from "./pages/admin/AdminProfile";
import UserDetail from "./pages/admin/UserDetail";
import AdminPassword from "./pages/admin/AdminPassword";
import UserPassword from "./pages/user/UserPassword";
import DriverPassword from "./pages/driver/DriverPassword";
import Subscription from "./pages/admin/Subscription";
import PaymentMode from "./pages/admin/PaymentMode";
import UserPayment from "./pages/user/UserPayment";
import PaymentHistory from "./pages/admin/PaymentHistory";
import UserTransaction from "./pages/user/UserTransaction";
import DriverPayment from "./pages/driver/DriverPayment";
import DriverTransaction from "./pages/driver/DriverTransaction";
import Company from "./pages/admin/Company";
import UserKyc from "./pages/user/UserKyc";
import Enquiry from "./pages/admin/Enquiry";
import UserEmergency from "./pages/user/UserEmergency";
import DriverEmergency from "./pages/driver/DriverEmergency";
import DriverTips from "./pages/driver/DriverTips";
import UserTips from "./pages/user/UserTips";

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/adminlogin" element={<AdminLogin />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/test" element={<LoginPage />} />

          {/* admin routes role = 5 */}
          <Route path="/admin/*" element={<ProtectedRoute role="5">
            <AdminDashboard />
          </ProtectedRoute>} />

          <Route path="/admin/profile" element={<ProtectedRoute role="5">
            <AdminProfile />
          </ProtectedRoute>} />

          <Route path="/admin/users" element={<ProtectedRoute role="5">
            <UserList />
          </ProtectedRoute>} />

          <Route path="/admin/userdetail/:uid" element={<ProtectedRoute role="5">
            <UserDetail />
          </ProtectedRoute>} />

          <Route path="/admin/config" element={<ProtectedRoute role="5">
            <Config />
          </ProtectedRoute>} />

          <Route path="/admin/geofence" element={<ProtectedRoute role="5">
            <Geofence />
          </ProtectedRoute>} />

          <Route path="/admin/vehicles" element={<ProtectedRoute role="5">
            <AdminVehicle />
          </ProtectedRoute>} />

          <Route path="/admin/country" element={<ProtectedRoute role="5">
            <Countries />
          </ProtectedRoute>} />

          <Route path="/admin/city" element={<ProtectedRoute role="5">
            <Cities />
          </ProtectedRoute>} />

          <Route path="/admin/chatmsg" element={<ProtectedRoute role="5">
            <ChatMsg />
          </ProtectedRoute>} />

          <Route path="/admin/change-password" element={<ProtectedRoute role="5">
            <AdminPassword />
          </ProtectedRoute>} />

          <Route path="/admin/subscription" element={<ProtectedRoute role="5">
            <Subscription />
          </ProtectedRoute>} />

          <Route path="/admin/payment-mode" element={<ProtectedRoute role="5">
            <PaymentMode />
          </ProtectedRoute>} />

          <Route path="/admin/payment-history" element={<ProtectedRoute role="5">
            <PaymentHistory />
          </ProtectedRoute>} />

          <Route path="/admin/company" element={<ProtectedRoute role="5">
            <Company />
          </ProtectedRoute>} />

          <Route path="/admin/enquiry" element={<ProtectedRoute role="5">
            <Enquiry />
          </ProtectedRoute>} />

          {/* user routes role = 2 */}
          <Route path="/user" element={<ProtectedRoute role="2">
            <UserDashboard />
          </ProtectedRoute>} />

          <Route path="/user/profile" element={<ProtectedRoute role="2">
            <UserProfile />
          </ProtectedRoute>} />

          <Route path="/user/map" element={<ProtectedRoute role="2">
            <UserMapWithDirection />
          </ProtectedRoute>} />

          <Route path="/user/change-password" element={<ProtectedRoute role="2">
            <UserPassword />
          </ProtectedRoute>} />

          <Route path="/user/payment" element={<ProtectedRoute role="2">
            <UserPayment />
          </ProtectedRoute>} />

          <Route path="/user/transactions" element={<ProtectedRoute role="2">
            <UserTransaction />
          </ProtectedRoute>} />

          <Route path="/user/kyc" element={<ProtectedRoute role="2">
            <UserKyc />
          </ProtectedRoute>} />
          <Route path="/user/emergency-contact" element={<ProtectedRoute role="2">
            <UserEmergency />
          </ProtectedRoute>} />

          <Route path="/user/tips" element={<ProtectedRoute role="2">
            <UserTips />
          </ProtectedRoute>} />


          {/* driver routes role = 1 */}
          <Route path="/driver" element={<ProtectedRoute role="1" >
            <DriverDashboard />
          </ProtectedRoute>} />

          <Route path="/driver/profile" element={<ProtectedRoute role="1" >
            <DriverProfile />
          </ProtectedRoute>} />

          <Route path="/driver/vehicle" element={<ProtectedRoute role="1" >
            <VehicleList />
          </ProtectedRoute>} />

          <Route path="/driver/vehicle_edit/:DVNo" element={<ProtectedRoute role="1" >
            <DriverVehicle />
          </ProtectedRoute>} />

          <Route path="/driver/kyc" element={<ProtectedRoute role="1" >
            <KycDetail />
          </ProtectedRoute>} />

          <Route path="/driver/map" element={<ProtectedRoute role="1" >
            <DriverMapWithDirections />
          </ProtectedRoute>} />

          <Route path="/driver/change-password" element={<ProtectedRoute role="1">
            <DriverPassword />
          </ProtectedRoute>} />

          <Route path="/driver/payment" element={<ProtectedRoute role="1">
            <DriverPayment />
          </ProtectedRoute>} />

          <Route path="/driver/transactions" element={<ProtectedRoute role="1">
            <DriverTransaction />
          </ProtectedRoute>} />

          <Route path="/driver/emergency-contact" element={<ProtectedRoute role="1">
            <DriverEmergency />
          </ProtectedRoute>} />

          <Route path="/driver/tips" element={<ProtectedRoute role="1">
            <DriverTips />
          </ProtectedRoute>} />


          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
